module.exports = __webpack_public_path__ + "img/ctfc.11ce2205.png";